/* eslint-disable jsx-a11y/no-distracting-elements */
import styles from "../first/first.module.scss";
import img from "../../../assets/svg/first_img.svg";
import newImg from "../../../assets/images/newland.png";
import newImg2 from "../../../assets/images/first2.png";
import newImg3 from "../../../assets/images/first3.png";
import newImg4 from "../../../assets/images/first4.png";
import Slider from "react-slick";
import { useState } from "react";
import Marquee from "react-fast-marquee";
import { useNavigate } from "react-router-dom";
const First = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  // slider

  var settings = {
    dots: true,
    infinite: true,

    autoplay: true,
    autoplaySpeed: 6000,
    afterChange: (index: any) => {
      // Update the active tab when the slider changes
      setActiveTab(index);
    },
    slidesToShow: 1,
    slidesToScroll: 1,
    // nextArrow: <CustomNextArrow />, // Use the custom component here
    // prevArrow: <CustomPrevArrow />,
  };

  return (
    <>
      <div className={`${styles.newCard} first_slick`}>
        <Slider {...settings}>
          <div className={styles.image_text}>
            <img src={newImg2} />
            <div className={styles.all_text}>
              <div className={`${"container_left"} ${styles.mobile_}`}>
                <div className={styles.text}>
                  <p>
                    Hassle free construction code inspection{" "}
                    <span> are now just a click away.</span>
                  </p>
                  {/* <p>
                    Everything you need to
                    <br /> start{" "}
                    <span>
                      the inspection <br /> of your home.
                    </span>
                  </p> */}
                </div>
                <div className={styles.create}>
                  Get in control of your project and schedule, track, and
                  monitor progress with ease.
                </div>
                <div className={styles.btn}>
                  <a
                    href="#category"
                    // onClick={() => {
                    //   navigate("/contactus");
                    // }}
                  >
                    Know more
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.image_text}>
            <img src={newImg3} />
            <div className={styles.all_text}>
              <div className={`${"container_left"} ${styles.mobile_}`}>
                <div className={styles.text}>
                  <p>
                    One digital platform, for Seamless{" "}
                    <span> construction code Inspection.</span>
                  </p>
                  {/* <p>
                    Everything you need to
                    <br /> start{" "}
                    <span>
                      the inspection <br /> of your home.
                    </span>
                  </p> */}
                </div>
                <div className={styles.create}>
                  Bringing Townships, Builders, Contractors, and Inspectors
                  together for timely project completion.
                </div>
                <div className={styles.btn}>
                  <a href="#manage">Learn more</a>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.image_text}>
            <img src={newImg} />
            <div className={styles.all_text}>
              <div className={`${"container_left"} ${styles.mobile_}`}>
                <div className={styles.text}>
                  <p>
                    Everything you need to start the{" "}
                    <span>construction code inspection.</span>
                  </p>
                </div>
                <div className={styles.create}>
                  Create or Manage your inspections with CID The Inspection
                  Company, all of your data in one place.
                </div>
                <div className={styles.btn}>
                  <button
                    onClick={() => {
                      navigate("/contactus");
                    }}
                  >
                    Schedule Now
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.image_text}>
            <img src={newImg4} />
            <div className={styles.all_text}>
              <div className={`${"container_left"} ${styles.mobile_}`}>
                <div className={styles.text}>
                  <p>
                    Commercial and residential construction{" "}
                    <span> code inspection done right.</span>
                  </p>
                  {/* <p>
                    Everything you need to
                    <br /> start{" "}
                    <span>
                      the inspection <br /> of your home.
                    </span>
                  </p> */}
                </div>
                <div className={styles.create}>
                  Work with qualified and licensed inspectors that cater to your
                  schedule.
                </div>
                <div className={styles.btn}>
                  <a
                    onClick={() => {
                      navigate("/contactus");
                    }}
                  >
                    Talk to us
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* <div className={styles.image_text}>
            <img src={img} />
            <div className={styles.all_text}>
              <div className={`${"container_left"} ${styles.mobile_}`}>
                <div className={styles.text}>
                  <p>
                    All in one hassle free code
                    <br />
                    <span>inspection platform</span>
                  </p>
                </div>
                <div className={styles.create}>
                  Building and renovation are big projects, your inspections
                  need <br /> not be one.
                </div>
                <div className={styles.btn}>
                  <button
                    onClick={() => {
                      navigate("/contactus");
                    }}
                  >
                    Schedule Now
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.image_text}>
            <img src={img} />
            <div className={styles.all_text}>
              <div className={`${"container_left"} ${styles.mobile_}`}>
                <div className={styles.text}>
                  <p>
                    A complete platform for{" "}
                    <span>
                      {" "}
                      <br />
                      all your code inspection <br /> needs.
                    </span>
                  </p>
                </div>
                <div className={styles.create}>
                  One stop solution for all your home and commercial code
                  inspection requirements,whether it’s building a new home,
                  renovating, or expanding. We have you covered!
                </div>
                <div className={styles.btn}>
                  <button
                    onClick={() => {
                      navigate("/contactus");
                    }}
                  >
                    Schedule Now
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.image_text}>
            <img src={img} />
            <div className={styles.all_text}>
              <div className={`${"container_left"} ${styles.mobile_}`}>
                <div className={styles.text}>
                  <p>
                    Find inspectors for all{" "}
                    {window.innerWidth <= 1366 && <br />} your{" "}
                    {window.innerWidth > 1367 && <br />} construction{" "}
                    <span>
                      code <br /> inspection needs.
                    </span>
                  </p>
                </div>
                <div className={styles.create}>
                  10 no. inspectors across 5 categories
                </div>
                <div className={styles.btn}>
                  <button
                    onClick={() => {
                      navigate("/contactus");
                    }}
                  >
                    Schedule Now
                  </button>
                </div>
              </div>
            </div>
          </div> */}
        </Slider>
      </div>

      <div className={styles.running}>
        <Marquee
          style={{ fontSize: "18px", fontWeight: "600", cursor: "ponter" }}
        >
          <p
            onClick={() => {
              navigate("/inspector-contact");
            }}
            style={{ padding: "0px 2px" }}
          >
            {" "}
            CID THE INSPECTION COMPANY | CID THE INSPECTION COMPANY | CID THE
            INSPECTION COMPANY | CID THE INSPECTION COMPANY | CID THE INSPECTION
            COMPANY | CID THE INSPECTION COMPANY | CID THE INSPECTION COMPANY |
          </p>
        </Marquee>
      </div>
    </>
  );
};

export default First;
